<template>
  <div class="promotion-records">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <!-- 使用现有的 GetUser 组件 -->
        <el-form-item label="选择用户">
          <el-row :gutter="10">
            <el-col :span="18">
              <el-input
                v-model="selectedUserName"
                placeholder="请选择用户"
                readonly
                style="width: 300px"
              >
                <template slot="append">
                  <el-button @click="openUserDialog" icon="el-icon-search">选择用户</el-button>
                </template>
              </el-input>
            </el-col>
            <el-col :span="6" v-if="selectedUser">
              <el-button @click="clearUserSelection" type="text" icon="el-icon-close">清除</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        
        <el-form-item label="推广状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="未开始" value="0"></el-option>
            <el-option label="进行中" value="1"></el-option>
            <el-option label="已结束" value="2"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="推广时间">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 用户信息卡片 -->
    <el-card v-if="selectedUser" class="user-info-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>用户信息</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="clearUserSelection">
          清除选择
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="user-info-item">
            <img :src="selectedUser.avatarUrl" class="user-avatar" width="40" height="40" />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="user-info-item">
            <label>用户ID：</label>
            <span>{{ selectedUser.user_id }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="user-info-item">
            <label>昵称：</label>
            <span>{{ selectedUser.nickName }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="user-info-item">
            <label>手机号：</label>
            <span>{{ selectedUser.mobile || '未填写' }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 数据统计 -->
    <el-card v-if="selectedUser" class="stats-card" shadow="never">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="stat-item">
            <div class="stat-value">{{ stats.total || 0 }}</div>
            <div class="stat-label">总推广</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="stat-item">
            <div class="stat-value">{{ stats.transformationNum || 0 }}</div>
            <div class="stat-label">总成功数</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="stat-item">
            <div class="stat-value">{{ stats.viewCount || 0 }}</div>
            <div class="stat-label">总浏览</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="stat-item">
            <div class="stat-value">{{ stats.successRate || 0 }}%</div>
            <div class="stat-label">转化率</div>
          </div>
        </el-col>
        <!-- <el-col :span="4">
          <div class="stat-item">
            <div class="stat-value">{{ teamInfo.people || 0 }}</div>
            <div class="stat-label">团队人数</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="stat-item">
            <el-button type="primary" @click="viewTeam" plain>查看团队</el-button>
          </div>
        </el-col> -->
      </el-row>
    </el-card>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table 
          size="small" 
          :data="tableData" 
          border 
          style="width: 100%" 
          v-loading="loading"
          @sort-change="handleSortChange"
        >
          <el-table-column prop="id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="title" label="推广标题" min-width="200">
            <template slot-scope="scope">
              <div class="promotion-title">{{ scope.row.title || '无标题' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="推广次数" width="100" align="center"></el-table-column>
          <el-table-column prop="success_num" label="成功次数" width="100" align="center"></el-table-column>
          <el-table-column prop="viewCount" label="浏览次数" width="100" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag 
                :type="getStatusTagType(scope.row.status)" 
                size="small"
              >
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="推广时间" width="180" sortable="custom"></el-table-column>
          <!-- <el-table-column prop="create_time" label="创建时间" width="180" sortable="custom"></el-table-column> -->
          <!-- <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button 
                @click="viewDetail(scope.row)" 
                type="text" 
                size="small"
              >查看详情</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background 
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!-- 使用现有的 GetUser 组件 -->
    <GetUser 
      :is_open="userDialogVisible" 
      @close="closeUserDialog"
      :multi="false"
    ></GetUser>

    <!-- 推广详情对话框 -->
    <el-dialog
      title="推广详情"
      :visible.sync="detailDialogVisible"
      width="60%"
      :before-close="handleDetailClose"
    >
      <promotion-detail 
        v-if="detailDialogVisible" 
        :promotion-id="currentPromotionId"
      ></promotion-detail>
    </el-dialog>

    <!-- 数据分析对话框 -->
    <el-dialog
      title="数据分析"
      :visible.sync="analysisDialogVisible"
      width="80%"
      :before-close="handleAnalysisClose"
    >
      <promotion-analysis 
        v-if="analysisDialogVisible" 
        :promotion-id="currentPromotionId"
      ></promotion-analysis>
    </el-dialog>
  </div>
</template>

<script>
import PromotionApi from '@/api/promotion.js';
import GetUser from '@/components/user/GetUser.vue';

// 推广详情组件（简化版）
const PromotionDetail = {
  props: ['promotionId'],
  template: `
    <div v-if="detailData">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="推广标题">{{ detailData.title }}</el-descriptions-item>
        <el-descriptions-item label="推广状态">
          <el-tag :type="getStatusTagType(detailData.status)">{{ getStatusText(detailData.status) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="推广次数">{{ detailData.num }}</el-descriptions-item>
        <el-descriptions-item label="成功次数">{{ detailData.success_num }}</el-descriptions-item>
        <el-descriptions-item label="浏览次数">{{ detailData.viewCount }}</el-descriptions-item>
        <el-descriptions-item label="转化率">{{ ((detailData.success_num / detailData.num) * 100).toFixed(2) }}%</el-descriptions-item>
        <el-descriptions-item label="推广时间" :span="2">{{ detailData.time }}</el-descriptions-item>
        <el-descriptions-item label="创建时间" :span="2">{{ detailData.create_time }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div v-else>
      <el-skeleton :rows="5" animated />
    </div>
  `,
  data() {
    return {
      detailData: null
    }
  },
  methods: {
    getStatusText(status) {
      const statusTextMap = { 0: '未开始', 1: '进行中', 2: '已结束' };
      return statusTextMap[status] || '';
    },
    getStatusTagType(status) {
      const typeMap = { 0: 'info', 1: 'success', 2: 'warning' };
      return typeMap[status] || 'info';
    },
    loadDetail() {
      // 调用API加载详情数据
      PromotionApi.getPromotionDetail({ id: this.promotionId }).then(res => {
        this.detailData = res.data;
      });
    }
  },
  mounted() {
    this.loadDetail();
  }
};

// 数据分析组件（简化版）
const PromotionAnalysis = {
  props: ['promotionId'],
  template: `
    <div>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-card>
            <div slot="header">基础数据</div>
            <div class="analysis-item">
              <div class="analysis-value">{{ analysisData.totalViews || 0 }}</div>
              <div class="analysis-label">总浏览量</div>
            </div>
            <div class="analysis-item">
              <div class="analysis-value">{{ analysisData.totalClicks || 0 }}</div>
              <div class="analysis-label">总点击量</div>
            </div>
            <div class="analysis-item">
              <div class="analysis-value">{{ analysisData.conversionRate || 0 }}%</div>
              <div class="analysis-label">转化率</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="16">
          <el-card>
            <div slot="header">趋势分析</div>
            <!-- 这里可以放置图表组件 -->
            <div style="height: 300px; display: flex; align-items: center; justify-content: center; color: #999;">
              趋势图表区域
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  `,
  data() {
    return {
      analysisData: {}
    }
  },
  methods: {
    loadAnalysis() {
      // 调用API加载分析数据
      PromotionApi.getPromotionAnalysis({ id: this.promotionId }).then(res => {
        this.analysisData = res.data;
      });
    }
  },
  mounted() {
    this.loadAnalysis();
  }
};

export default {
  components: {
    GetUser,
    PromotionDetail,
    PromotionAnalysis
  },
  data() {
    return {
      /*是否加载完成*/
      loading: false,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单*/
      searchForm: {
        user_id: '',
        status: '-1',
        dateRange: []
      },
      /*选中的用户*/
      selectedUser: null,
      /*选中的用户名称（用于显示）*/
      selectedUserName: '',
      /*用户选择对话框显示状态*/
      userDialogVisible: false,
      /*统计数据*/
      stats: {},
      /*团队信息*/
      teamInfo: {},
      /*详情对话框显示*/
      detailDialogVisible: false,
      /*分析对话框显示*/
      analysisDialogVisible: false,
      /*当前推广ID*/
      currentPromotionId: null
    };
  },
  created() {
    // 可以在这里初始化一些数据
  },
  methods: {
    /*打开用户选择对话框*/
    openUserDialog() {
      this.userDialogVisible = true;
    },

    /*关闭用户选择对话框*/
    closeUserDialog(e) {
      this.userDialogVisible = false;
      if (e.type === 'success') {
        // 单选模式下，e.params 是单个用户对象
        const user = e.params;
        this.selectedUser = user;
        this.selectedUserName = `${user.nickName} (ID:${user.user_id})`;
        this.searchForm.user_id = user.user_id;
        
        // 选择用户后自动加载数据
        this.loadUserStats();
        this.loadTeamInfo();
        this.getTableList();
      }
    },

    /*清除用户选择*/
    clearUserSelection() {
      this.selectedUser = null;
      this.selectedUserName = '';
      this.searchForm.user_id = '';
      this.tableData = [];
      this.stats = {};
      this.teamInfo = {};
    },

    /*加载用户统计*/
    loadUserStats() {
      if (!this.selectedUser) return;
      
      PromotionApi.getPromotionStats({
        user_id: this.selectedUser.user_id,
        status: this.searchForm.status
      }).then(res => {
        this.stats = res.data || {};
      });
    },

    /*加载团队信息*/
    loadTeamInfo() {
      if (!this.selectedUser) return;
      
      PromotionApi.getTeamInfo({
        user_id: this.selectedUser.user_id
      }).then(res => {
        this.teamInfo = res.data || {};
      });
    },

    /*获取列表*/
    getTableList() {
      if (!this.selectedUser) {
        this.tableData = [];
        return;
      }

      this.loading = true;
      let params = {
        ...this.searchForm,
        page: this.curPage,
        list_rows: this.pageSize,
        user_id: this.selectedUser.user_id
      };

      // 处理日期范围
      if (params.dateRange && params.dateRange.length === 2) {
        params.start_date = params.dateRange[0];
        params.end_date = params.dateRange[1];
        delete params.dateRange;
      }

      PromotionApi.getPromotionList(params).then(res => {
        this.loading = false;
        this.tableData = res.data.list.data || [];
        this.totalDataNumber = res.data.list.total || 0;
      }).catch(() => {
        this.loading = false;
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*排序变化*/
    handleSortChange({ column, prop, order }) {
      // 处理排序逻辑
      console.log('排序:', prop, order);
      this.getTableList();
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      if (this.selectedUser) {
        this.loadUserStats();
      }
      this.getTableList();
    },

    /*重置搜索*/
    resetSearch() {
      this.searchForm = {
        user_id: this.searchForm.user_id, // 保留用户选择
        status: '-1',
        dateRange: []
      };
      if (this.selectedUser) {
        this.loadUserStats();
      }
      this.getTableList();
    },

    /*查看详情*/
    viewDetail(row) {
      this.currentPromotionId = row.id;
      this.detailDialogVisible = true;
    },

    /*查看数据分析*/
    viewAnalysis(row) {
      this.currentPromotionId = row.id;
      this.analysisDialogVisible = true;
    },

    /*查看团队*/
    viewTeam() {
      if (this.selectedUser) {
        // 在新窗口打开团队页面
        window.open(`/user/pages/agent/index?user_id=${this.selectedUser.user_id}`, '_blank');
      }
    },

    /*关闭详情对话框*/
    handleDetailClose() {
      this.detailDialogVisible = false;
      this.currentPromotionId = null;
    },

    /*关闭分析对话框*/
    handleAnalysisClose() {
      this.analysisDialogVisible = false;
      this.currentPromotionId = null;
    },

    /*获取状态文本*/
    getStatusText(status) {
      const statusTextMap = {
        0: '未开始',
        1: '进行中',
        2: '已结束',
      };
      return statusTextMap[status] || '';
    },

    /*获取状态标签类型*/
    getStatusTagType(status) {
      const typeMap = {
        0: 'info',
        1: 'success',
        2: 'warning'
      };
      return typeMap[status] || 'info';
    }
  }
};
</script>

<style scoped>
.promotion-records {
  padding: 20px;
}

.user-info-card {
  margin-bottom: 20px;
}

.user-info-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.user-info-item label {
  font-weight: bold;
  color: #606266;
  margin-right: 8px;
}

.user-avatar {
  border-radius: 50%;
}

.stats-card {
  margin-bottom: 20px;
}

.stat-item {
  text-align: center;
  padding: 20px 0;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: #909399;
}

.promotion-title {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-item {
  text-align: center;
  padding: 20px 0;
}

.analysis-value {
  font-size: 28px;
  font-weight: bold;
  color: #409EFF;
  margin-bottom: 8px;
}

.analysis-label {
  font-size: 14px;
  color: #909399;
}

.common-seach-wrap {
  margin-bottom: 20px;
}

.product-content {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/report/promotion_log.vue